import { render } from "./topics-list.vue?vue&type=template&id=04a6aced&scoped=true"
import script from "./topics-list.vue?vue&type=script&lang=js"
export * from "./topics-list.vue?vue&type=script&lang=js"

import "./topics-list.vue?vue&type=style&index=0&id=04a6aced&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a6aced"]])

export default __exports__